import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { addMonthsToDate, formatDate } from 'utils/datetime'

export const useGetStepsByPeriod = () => {
  const { period } = usePeriodContext()

  const start = period?.startDate
  const phase2Start = addMonthsToDate(start, 1)

  return [
    {
      title: formatDate(start, 'MMMM'),
      description: ['Perencanaan dan Persetujuan Rencana.'],
    },
    {
      title: `${formatDate(phase2Start, 'MMMM')} - ${formatDate(
        period?.endDate,
        'MMMM'
      )}`,
      description: [
        'Persiapan Praktik Kinerja.',
        'Pelaksanaan Praktik Kinerja: Observasi.',
        'Pelaksanaan Praktik Kinerja: Tindak Lanjut.',
        'Penilaian dan Penetapan Predikat Kinerja.',
      ],
    },
  ]
}
